import { connect as formikConnect, Field } from 'formik'; // TODO WEBCLIENT-7776 rename all instances of formik connect to "formikConnect" to avoid confusion
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { linkClicked, webViewModeInteraction } from '../../../../actions/UseCases';
import { StatsOnboardingActions } from '../../../../constants/Onboarding';
import { getInDomain } from '../../../../domains/externalUtils';
import { createBEM } from '../../../../lib/utils/css';
import ButtonT3 from '../../ButtonT3/ButtonT3';
import { ButtonT3Theme } from '../../ButtonT3/constants';
import IconInteractive from '../../IconInteractive/IconInteractive';
import * as FormUtils from '../utils';

import { FormInputControls, FormInputNames, FormInputTypes } from './constants';

import './FormInput.scss';

/**
 * @param  {object} inputAttributes - Provides data to create a select
 * @param  {string} inputControlAttributes - provides type of CLEAR | SHOW/HIDE and QA tag
 * @param  {Any} formik - Provided by formik connect
 */

class FormInput extends React.Component {
  static propTypes = {
    formik: PropTypes.object,
    innerRef: PropTypes.shape({ current: PropTypes.instanceOf(React.Element) }),
    inputAttributes: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      placeholder: PropTypes.string,
      qaTag: PropTypes.string,
      maxLength: PropTypes.number,
      readOnly: PropTypes.bool,
    }),
    inputControlAttributes: PropTypes.shape({
      type: PropTypes.string,
      qaTag: PropTypes.string,
      onClick: PropTypes.func,
    }),
    linkClicked: PropTypes.func,
    webViewModeInteraction: PropTypes.func,
  };

  state = {
    type: this.props.inputAttributes.type || FormInputTypes.TEXT,
  };

  clear = () => {
    const { inputAttributes, formik, inputControlAttributes } = this.props;
    formik.setFieldValue(inputAttributes.name, '');
    formik.setFieldTouched(inputAttributes.name, false);
    if (inputControlAttributes && inputControlAttributes.onClick) {
      inputControlAttributes.onClick();
    }
  };

  showHide = () => {
    const inputControlAttributes = this.props.inputControlAttributes;
    const newType =
      this.state.type === FormInputTypes.TEXT ? FormInputTypes.PASSWORD : FormInputTypes.TEXT;
    this.setState({ type: newType });
    if (inputControlAttributes && inputControlAttributes.onClick) {
      inputControlAttributes.onClick();
    }
  };

  getInputControlProps = () => {
    const { type, qaTag } = this.props.inputControlAttributes;
    let buttonContent;
    let buttonOnClick;
    switch (type) {
      case FormInputControls.SHOW:
        buttonContent =
          this.state.type === FormInputTypes.PASSWORD
            ? FormInputControls.SHOW
            : FormInputControls.HIDE;
        buttonOnClick = this.showHide;
        break;
      case FormInputControls.CLEAR:
        buttonContent = <IconInteractive glyphLookup={FormInputControls.CLEAR} />;
        buttonOnClick = this.clear;
        break;
      default:
    }
    return {
      buttonContent,
      buttonOnClick,
      ariaLabel: type,
      inputControlQaTag: qaTag,
    };
  };

  renderInputControl = () => {
    const { buttonOnClick, buttonContent, ariaLabel, inputControlQaTag } =
      this.getInputControlProps();
    return (
      <div className='Form__input__control'>
        <ButtonT3
          onClick={buttonOnClick}
          theme={ButtonT3Theme.LIGHT_TRANSPARENT}
          isNoPadding={true}
          ariaLabel={ariaLabel}
          qaTag={inputControlQaTag}
        >
          {buttonContent}
        </ButtonT3>
      </div>
    );
  };

  getFormattedInputAttributes = () => {
    // get attributes needed to format, then delete them
    const { qaTag } = this.props.inputAttributes;
    delete this.props.inputAttributes.qaTag;
    return {
      ...this.props.inputAttributes,
      'data-qa': qaTag,
    };
  };

  onBlur = () => {
    // Send stats call when user enters into email or pw fields
    let eventName;
    const name = this.props.inputAttributes.name;
    let action;
    let viewMode;
    let webViewModeAction;
    if (this.props.formik.values[name] === '') {
      return;
    }
    switch (name) {
      case FormInputNames.EMAIL:
        action = StatsOnboardingActions.EMAIL_INPUT;
        break;
      case FormInputNames.PASSWORD:
        action = StatsOnboardingActions.PWD_INPUT;
        break;
      case FormInputNames.NEW_PASSWORD:
        action = StatsOnboardingActions.NEW_PWD_INPUT;
        break;
      case FormInputNames.CONFIRM_PASSWORD:
        action = StatsOnboardingActions.CONFIRM_PWD_INPUT;
        break;
      case FormInputNames.OFFER_CODE:
        eventName = getInDomain('stats.constants.Events.UPGRADE_PAGE');
        viewMode = getInDomain('stats.constants.ViewModes.SETTINGS');
        webViewModeAction = StatsOnboardingActions.USER_INPUT;
    }
    if (action) {
      this.props.linkClicked(action);
    }
    this.props.webViewModeInteraction({
      event_name: eventName,
      action: webViewModeAction || null,
      view_mode: viewMode || StatsOnboardingActions.USER_INPUT,
    });
  };

  renderInput = ({ hasControl }) => {
    const { formik, inputAttributes } = this.props;
    const inputClasses = createBEM('Form__input', {
      hasControl,
      error: FormUtils.shouldShowError(formik, inputAttributes.name),
    });
    return (
      <Field
        innerRef={this.props.innerRef}
        className={inputClasses}
        {...this.getFormattedInputAttributes()}
        type={this.state.type}
        onBlur={this.onBlur}
      />
    );
  };

  render() {
    const { formik, inputAttributes, inputControlAttributes } = this.props;
    const containerClasses = createBEM('FormInput__container', {
      readOnly: inputAttributes.readOnly,
    });
    const hasControl =
      !!FormUtils.getValues(formik.values, inputAttributes.name) && inputControlAttributes;
    return (
      <div className={containerClasses}>
        {this.renderInput({ hasControl })}
        {hasControl && this.renderInputControl()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  linkClicked,
  webViewModeInteraction,
};

export default connect(null, mapDispatchToProps)(formikConnect(FormInput));
